<section>

  <div class="flex justify-between items-end">
    <div>
      <h1>classes</h1>
    </div>
    <div>
      <button *ngIf="create_class === true" (click)="openModal()" class="btn btn-sm flex items-center btn-primary"><i class="ri-add-line"></i> Create
        class</button>
    </div>
  </div>

  <div class="mt-5">
    <div class="bg-white border border-gray-200 rounded-lg flex items-center w-2/5 px-3"><i
        class="ri-search-2-line"></i> <input type="text" [(ngModel)]="searchStr" (ngModelChange)="search()" placeholder="Search" class="outline-none ml-2 w-full py-2">
    </div>
  </div>

  <div class="p-5 bg-white rounded-lg mt-5 border"  *ngIf="view_class === true" >

    <div class="overflow-x-auto">
      <table class="table table-auto w-full">
        <!-- head -->
        <thead>
          <tr>
            <!-- <th class="w-14"><input type="checkbox" class="checkbox checkbox-sm" /></th> -->
            <th class="w-auto">class Name</th>
            <th>department</th>
            <th>No. of Batch</th>
            <th class="w-56">Action</th>
          </tr>
        </thead>
        <tbody>
           <!-- Loader during fetching -->
  @if (isFetching) {
    <tr>
      <td colspan="5" class="py-10">
        <div class="flex justify-center">
          <app-loader></app-loader>
        </div>
      </td>
    </tr>
  } @else {
    @if (classesList && classesList.length) {
      @for (i of classesList; track $index) {
        <tr>
          <!-- <th><input type="checkbox" class="checkbox checkbox-sm" /></th> -->
          <td class="break-words">{{ i?.class_name }}</td>
          <td>{{ i?.department?.department_name }}</td>
          <td>{{ i?.batch_count }}</td>
          <td>
            <div class="flex gap-2 justify-center">
              <!-- <button class="btn btn-sm flex items-center btn-light" *ngIf="view_class === true" (click)="openPerformance(i?.id)"><i class="ri-eye-line"></i></button> -->
              <button class="btn btn-sm flex items-center btn-light" (click)="openModal(i)" *ngIf="edit_class === true"><i class="ri-pencil-line"></i></button>
              <button class="btn btn-sm flex items-center btn-light" (click)="deleteClass(i?.id)" *ngIf="delete_class === true"><i class="ri-delete-bin-line"></i></button>
              <a [routerLink]="['/performance', 'class', i?.id]" class="btn btn-sm flex items-center btn-light" *ngIf="class_performance === true"><i class="ri-bar-chart-line"></i></a>
              <button class="btn btn-sm flex items-center btn-light" *ngIf="class_communication === true" (click)="openChat(i?.id)"><i class="ri-message-3-line"></i></button>
            </div>
          </td>
        </tr>
      }
    } @else {
      <tr>
        <td colspan="5" class="py-10">
          <div class="flex justify-center">
            <p class="font-mono italic">No data to display.</p>
          </div>
        </td>
      </tr>
    }
  }
        </tbody>
      </table>
    </div>



  </div>

  <div class="mt-5 flex justify-center">
    <app-pagination [data]="paginationData" (pageChange)="pageChange($event)"></app-pagination>
  </div>

</section>

<!-- create/edit class modal -->
<dialog id="addclassModal" class="modal" #modalClasses appPreventEscClose>
  <div class="modal-box max-w-sm">

    <div class="flex justify-between items-center font-semibold">
      <p>Create class</p>
      <button  (click)="closeModal()" class="btn btn-circle btn-sm btn-light flex justify-center items-center"><i
          class="ri-close-line"></i>
      </button>
    </div>
    <hr class="mt-4 mb-1">

    <form [formGroup]="classFrom" (ngSubmit)="onsubmit()">


      <label class="form-control w-full ">
        <div class="label">
          <span class="label-text req">Class Name</span>
        </div>
        <input formControlName="class_name" type="text"
          [ngClass]="{'error': classFrom.get('class_name')?.invalid && classFrom.get('class_name')?.touched}"
          placeholder="Type here" class="input input-bordered w-full" />
      </label>
      @if (classFrom.get('class_name')?.invalid && classFrom.get('class_name')?.touched) {
      <span class="text-xs text-red-500">
        @if (classFrom.get('class_name')?.errors?.['whitespaceOnly']) {
          Class name cannot contain only spaces.
        } @else if (classFrom.get('class_name')?.errors?.['minlength']) {
          Class name must be at least 2 characters.
        } @else if (classFrom.get('class_name')?.errors?.['maxlength']) {
          Class name must be at most 50 characters.
        } @else if (classFrom.get('class_name')?.errors?.['pattern']) {
          Class name can only contain letters, numbers, spaces, hyphen, and ampersand.
        } @else {
          Class name is required.
        }
      </span>
      }

      <label class="form-control w-full mt-2">
        <div class="label">
          <span class="label-text req">Department</span>
        </div>
        <select formControlName="department_id" class="select select-bordered w-full"
          [ngClass]="{'error': classFrom.get('department_id')?.invalid && classFrom.get('department_id')?.touched}">
          <option disabled selected>Select Department</option>
          @for (i of (deapertmentList$ | async); track $index) {
          <option value="{{i?.id}}">{{i?.department_name}}</option>
          }
        </select>
      </label>
      @if (classFrom.get('department_id')?.invalid && classFrom.get('department_id')?.touched) {
      <span class="text-xs text-red-500">Department is required</span>
      }

      <label class="form-control w-full mt-2">
        <div class="label">
          <span class="label-text req">Add Batch</span>
        </div>
        <div class="join w-full mb-1">
          <input #batchInput [formControl]="batchNameControl" type="text" class="input input-bordered join-item w-full"
            [ngClass]="{'error': batchNameControl.invalid && batchNameControl.touched}"
            placeholder="Enter Batch Name" (input)="onBatchInput()" (blur)="onBatchInput()" />
          <button type="button" class="btn btn-square bg-zinc-700 text-white join-item rounded-r-lg"
            (click)="addBatch()"><i class="ri-add-line"></i></button>
        </div>
        <span class="text-xs text-zinc-500">Space will be replaced with hyphen</span>
      </label>
      @if (batchNameControl.invalid && batchNameControl.touched) {
      <span class="text-xs text-red-500">{{ batchError || 'Batch name is required' }}</span>
      }

      @if (addedBatchArray) {
      <div class="mt-2 flex gap-2 flex-wrap">
        @for (i of addedBatchArray; track $index) {
        <span class="text-xs bg-zinc-200 text-zinc-600 px-2 py-1 rounded-lg flex gap-2 items-center">{{i}}<button
            type="button" (click)="removeBatch($index)"><i class="ri-close-line"></i></button></span>
        }
      </div>
      }


      <div class="mt-5 flex justify-end gap-3">
        <button type="submit" class="btn btn-sm btn-primary " [disabled]="isreqSent">
          @if (isreqSent) {
          <i class="ri-loader-2-line animate-spin"></i>
          }@else {
          <span>Save</span>
          }
        </button>
        <button type="button" class="btn btn-sm btn-light" (click)="closeModal()">Cancel</button>
      </div>

    </form>
  </div>
</dialog>
<!-- create/edit class modal -->
